/**
 * PageHero — the layered header card used across main tabs.
 *
 * Replaces flat title+paragraph headers with a soft gradient card,
 * kicker line, optional note, action row, and a decorative dashed
 * route with a destination pin (the Memory Lane motif).
 */

import React from "react";
import { JourneyLine } from "@/components/Brand";

export function PageHero({ kicker, kickerIcon: KickerIcon, title, titleTestId, subtitle, note, actions, children, testId, className = "" }) {
    return (
        <header
            data-testid={testId || "page-hero"}
            className={`relative overflow-hidden rounded-3xl border border-[#DFE5E0] bg-white p-6 md:p-9 shadow-[0_6px_24px_rgba(31,38,36,0.05)] ${className}`}
        >
            <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-br from-teal-soft/60 via-transparent to-transparent pointer-events-none" />
            <div aria-hidden="true" className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-teal-soft/50 blur-2xl pointer-events-none" />
            <JourneyLine className="absolute right-4 bottom-3 hidden md:block pointer-events-none" width={230} opacity={0.55} />
            <div className="relative">
                {kicker && (
                    <p className="text-xs uppercase tracking-wider font-semibold text-teal-dark flex items-center gap-1.5 mb-2">
                        {KickerIcon && <KickerIcon size={13} strokeWidth={2.2} />} {kicker}
                    </p>
                )}
                <h1 className="text-4xl md:text-5xl font-heading font-semibold tracking-tight text-[#12776F]" data-testid={titleTestId}>
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-3 text-base md:text-lg text-[#4C5551] leading-relaxed max-w-2xl">{subtitle}</p>
                )}
                {note && <p className="mt-2 text-xs text-[#6E7A74] italic">{note}</p>}
                {actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
                {children}
            </div>
        </header>
    );
}
